<!-- This component was reworked to use templates and new validators !  -->

<div class="row">

  <div class="col-md-12">

    <!-- <div *ngIf="entryCreated" class="slideDownNotification"> 
    <wallet-info-card 
        [title]="translate.instant('notifications.userCreated')"
        [type]="'primary'" 
        [nbIconName]="'nb-person'"
        [buttonCaption]="translate.instant('dict.view')"
        [buttonURL]="navigate.linkToProfileById(entryCreated.id)"
        >
        {{translate.instant('notifications.willReceiveEmail')}}<br> {{translate.instant('notifications.withAllInformation')}}
      </wallet-info-card>
    </div> -->



    <nb-card class="slideUp">
      <nb-card-header>{{translate.instant(titleKey)}}</nb-card-header>
      <nb-card-body>
<form [formGroup]="entryForm"> 

<div *ngFor="let field of entry; let i = index">
  
  <!-- left column -->
  <div *ngIf="(i % 2 == 0) && field.visible != false" class="row">
    <div class="col-sm-6">
      <div class="form-group" nbPopover="{{field.helpMessage}}" nbPopoverTrigger="noop" nbPopoverContext="{{field.name}}" >
        <label for="{{'input' + field.name}}" class="label">{{field.label}}</label>
          
        <div style="display: flex;" [ngSwitch]="field.type">
          
          <!-- this template outlet gets templates for the different data types based on their type. the template ref for option type is called #option, etc. -->   
          <ng-container *ngTemplateOutlet="['dateAfter', 'dateBefore', 'dateAny','options'].includes(field.type) ? this[field.type] : this.defaultInputTemplate ; context: {$implicit : field}"></ng-container>
             
          <nb-icon class="centerIcon" [icon]="'question-mark-circle-outline'" pack="eva"
            nbPopover="{{field.helpMessage}}" nbPopoverTrigger="hover"
            nbPopoverPlacement="right"></nb-icon>
        </div>

      </div>
    </div>

<!-- right column -->
    <div *ngIf="(i + 1 < visiblePropCount) && field.visible != false" class="col-sm-6">
      <div class="form-group" nbPopover="{{entry[i + 1].helpMessage}}" nbPopoverTrigger="noop" nbPopoverContext="{{entry[i + 1].name}}">
        <label for="{{'input' + entry[i + 1].name}}" class="label">{{entry[i + 1].label}}</label>
        <div *ngLet="(entry[i + 1]) as field" style="display: flex;" [ngSwitch]="entry[i + 1].type">
          
          <!-- this template outlet gets templates for the different data types based on their type. template ref for option type is called #option, etc. -->
          <ng-container *ngTemplateOutlet="['dateAfter', 'dateBefore', 'dateAny','options'].includes(field.type) ? this[field.type] : this.defaultInputTemplate ; context: {$implicit : field}"></ng-container>
     
          <nb-icon class="centerIcon" [icon]="'question-mark-circle-outline'" pack="eva"
            nbPopover="{{entry[i + 1].helpMessage}}" nbPopoverTrigger="hover" nbPopoverContext="{{entry[i + 1].name}}"
            nbPopoverPlacement="right"></nb-icon>
        </div>
      </div>
    </div>
  </div>
</div>


<address-search (locationAddress)="addAddressToFormInput($event)" [context]="'create'"></address-search>

<!-- button -->
<div class="form-group row">
  <div class="col-sm-9" style="margin-top: 25px;">
    <button type="submit" 
    [disabled]="showSpinnerOnCreateButton " 
    (click)="createNewUser()"
    nbButton status="primary"
    nbButton 
    matRipple 
    status="primary" 
    size="large" 
    [nbSpinner]="showSpinnerOnCreateButton || entryForm.pending" 
    nbSpinnerStatus="primary" 
    nbSpinnerSize="large" 
    >{{translate.instant(submitLabelKey)}}</button>
  </div>
  
<!--   <div class="col-sm-9" style="margin-top: 25px;">
    <button type="submit" 
    (click)="logForm()"
    nbButton status="primary"
    nbButton 
    matRipple 
    status="primary" 
    size="large" 
    [nbSpinner]="showSpinnerOnCreateButton" 
    nbSpinnerStatus="primary" 
    nbSpinnerSize="large" 
    nbSpinnerMessage=""
    >Log Form Status</button>
  </div> -->

</div>
</form>
        <!-- <button type="submit" nbButton>Submit</button> -->
      </nb-card-body>
    </nb-card>

  </div>
</div>


<!-- Datatype templates start !  -->

<!-- date (all) --> 
<ng-template #dateAll let-field [formGroup]="entryForm"> 
  <app-date-input [parentRef]="this" [field]="field"> </app-date-input>
</ng-template>


<!-- Options -->
<ng-template #options let-field [formGroup]="entryForm"> 
  <app-options-input [parentRef]="this" [field]="field"> </app-options-input>
</ng-template>

<!-- if normal input (as reused component) -->
<ng-template #defaultInputTemplate let-field [formGroup]="entryForm">
   <!-- We pass down the template variable 'field' into the reused child, as it does not exist on this component itself and therefore cannot be referenced! -->
  <app-standard-input [parentRef]="this" [field]="field"> </app-standard-input>
</ng-template>

<!-- Datatype templates end !  -->

<!-- success dialog (replaces the top notification bar) -->
<ng-template #createdDialog let-dialogRef="dialogRef">
  <nb-card class="created-dialog">
    <nb-card-body class="dialog-body">
      <div class="dialog-success-badge">
        <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
      </div>
      <h5 class="dialog-title">{{translate.instant('notifications.userCreated')}}</h5>
      <p class="dialog-message">
        {{translate.instant('notifications.willReceiveEmail')}}
        {{translate.instant('notifications.withAllInformation')}}
      </p>
    </nb-card-body>
    <nb-card-footer class="dialog-actions">
      <button nbButton matRipple status="primary" class="dialog-primary-action" (click)="goToHome(dialogRef)">
        {{translate.instant('terms.home')}}
      </button>
      <div class="dialog-secondary-actions">
        <button nbButton matRipple outline status="primary" (click)="goToCreatedProfile(dialogRef)">
          {{translate.instant('terms.viewCreatedUser')}}
        </button>
        <button nbButton matRipple outline status="primary" (click)="createAnotherUser(dialogRef)">
          {{translate.instant('terms.createAnother')}}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
